import { render } from "./LeftSidebarLayout.vue?vue&type=template&id=59d28edc"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student/LeftSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59d28edc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59d28edc', __exports__)) {
    api.reload('59d28edc', __exports__)
  }
  
  module.hot.accept("./LeftSidebarLayout.vue?vue&type=template&id=59d28edc", () => {
    api.rerender('59d28edc', render)
  })

}


export default __exports__